export default __webpack_public_path__ + "static/media/subset~HtbyOZFe.ef8f8024.svg";